<template>
	<router-link class="search-link" :to="{ name: 'search' }">
		<svg
			class="search-link__icon"
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="8"
				cy="8"
				r="7"
				stroke="var(--dark-blue)"
				stroke-width="1.5"
			/>
			<path
				d="M13 13L16 16"
				stroke="var(--dark-blue)"
				stroke-width="1.5"
				stroke-linecap="round"
			/>
		</svg>

		<span class="search-link__text visible-desktop">{{
			$t("nav.search")
		}}</span>
	</router-link>
</template>

<script>
export default {
	name: "SearchIcon",
};
</script>

<style lang="scss">
.search-link {
	margin: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	@media (min-width: 1023px) {
		height: auto;
		width: auto;
		flex-direction: row;
		padding: 5px 10px;
		border-radius: 4px;
		margin: 5px 5px 5px 0;
		cursor: pointer;
	}
	&__text {
		font-size: var(--font-normal);
		white-space: nowrap;
		color: var(--black);
	}
	&__icon {
		width: 22px;
		path {
			fill: var(--black);
		}
		@media (min-width: 1023px) {
			width: 15px;
			margin-right: 5px;
			path {
				fill: var(--black);
			}
		}
	}
}
</style>
